var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_6857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 12.9895C10.9986 12.0461 11.264 11.1215 11.7656 10.3224C12.2672 9.52339 12.9845 8.88246 13.8348 8.47362C14.6851 8.06479 15.6336 7.90471 16.5709 8.01187C17.5083 8.11903 18.3961 8.48906 19.1321 9.07924C19.8683 9.66943 20.4224 10.4557 20.7307 11.3474C21.0389 12.239 21.0889 13.1996 20.8745 14.1184C20.6603 15.0372 20.1905 15.8767 19.5196 16.5399C18.8487 17.2032 18.0039 17.6632 17.0827 17.8668C16.7805 17.9264 16.508 18.0882 16.3108 18.3248C16.1137 18.5616 16.004 18.8588 16 19.1668V20.6508",
    stroke: "#181B5E",
    strokeWidth: 1.42329,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 31.3347C24.4697 31.3347 31.3346 24.4697 31.3346 16.0013C31.3346 7.53294 24.4697 0.667969 16.0013 0.667969C7.53294 0.667969 0.667969 7.53294 0.667969 16.0013C0.667969 24.4697 7.53294 31.3347 16.0013 31.3347Z",
    stroke: "#181B5E",
    strokeWidth: 1.42329,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0052 24.6559C15.8211 24.6559 15.6719 24.5067 15.6719 24.3226C15.6719 24.1386 15.8211 23.9893 16.0052 23.9893",
    stroke: "#181B5E",
    strokeWidth: 1.42329
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0039 24.6559C16.188 24.6559 16.3372 24.5067 16.3372 24.3226C16.3372 24.1386 16.188 23.9893 16.0039 23.9893",
    stroke: "#181B5E",
    strokeWidth: 1.42329
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_6857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/helpCircle.87ae57148a7297427a48f181a6269964.svg";
export { ForwardRef as ReactComponent };